export const SUCCESS_COLOR = "#23d161";

/**
 * @constant
 */
export const FILES_ICONS = {
  "text/xml": "mdi-file-xml",
  "image/gif": "mdi-file-image",
  "image/jpeg": "mdi-file-image",
  "text/plain": "mdi-file",
  "image/png": "mdi-file-image",
  "image/x-ms-bmp": "mdi-file-image",
  "image/svg+xml": "mdi-file-image",
  "image/webp": "mdi-file-image",
  "application/msword": "mdi-file-document",
  "application/pdf": "mdi-file-pdf",
  "application/vnd.ms-excel": "mdi-file-excel",
  "application/vnd.ms-powerpoint": "mdi-file-powerpoint",
  "application/vnd.wap.wmlc": "mdi-file-music",
  "application/zip": "mdi-file-hidden",
  "audio/mpeg": "mdi-file-music",
  "audio/ogg": "mdi-file-music",
  "video/3gpp": "mdi-file-video",
  "video/mpeg": "mdi-file-video",
  "audio/wav": "mdi-file-music",
  "video/quicktime": "mdi-file-video",
  "video/x-flv  ": "mdi-file-video",
  "video/x-ms-wmv": "mdi-file-video",
  "video/x-msvideo ": "mdi-file-video",
  "video/mp4": "video",
};

/**
 * @constant
 */
export const DOC_TYPES = {
  "text/xml": "document",
  "image/gif": "image",
  "image/jpeg": "image",
  "image/jpg": "image",
  "text/plain": "document",
  "image/png": "image",
  "image/x-ms-bmp": "image",
  "image/svg+xml": "image",
  "image/webp": "image",
  "application/msword": "document",
  "application/pdf": "pdf",
  "application/vnd.ms-excel": "document",
  "application/vnd.ms-powerpoint": "document",
  "application/vnd.wap.wmlc": "audio",
  "application/zip": "compress",
  "audio/mpeg": "audio",
  "audio/ogg": "audio",
  "video/3gpp": "video",
  "video/mpeg": "video",
  "audio/wav": "audio",
  "video/quicktime": "video",
  "video/x-flv  ": "video",
  "video/x-ms-wmv": "video",
  "video/x-msvideo ": "video",
  "video/mp4": "video",
};

/**
 * @constant
 */
export const MIME_TYPES = {
  xml: "text/xml",
  html: "text/html",
  gif: "image/gif",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  jfif: "image/jpeg",
  txt: "text/plain",
  png: "image/png",
  bmp: "image/x-ms-bmp",
  svg: "image/svg+xml",
  webp: "image/webp",
  doc: "application/msword",
  pdf: "application/pdf",
  xls: "application/vnd.ms-excel",
  ppt: "application/vnd.ms-powerpoint",
  wmlc: "application/vnd.wap.wmlc",
  zip: "application/zip",
  mp3: "audio/mpeg",
  ogg: "audio/ogg",
  opus: "audio/opus",
  amr: "audio/amr",
  acc: "audio/acc",
  aac: "audio/aac",
  aacp: "audio/aacp",
  "3gpp": "video/3gpp",
  "3gp": "video/3gpp",
  mpeg: "video/mpeg",
  wav: "audio/wav",
  mpg: "video/mpeg",
  mov: "video/quicktime",
  flv: "video/x-flv  ",
  wmv: "video/x-ms-wmv",
  avi: "video/x-msvideo ",
  m4v: "video/mp4",
  mp4: "video/mp4",
  vnd: "application/msword",
  plain: "text/plain",
  csv: "text/csv",
  octet: "application/octet-stream",
};

export const MAX_FILE_SIZE = 70 * 1024 * 1024;
export const MAX_FILE_SIZE_MESSAGE =
  "El archivo supera el límite máximo de 70MB";
export const FILE_PLACEHOLDER = "Carga un archivo";

export const REQUIRED_MESSAGE = "Este campo es requerido";

export const DOCUMENT_TYPES = [
  { value: "CC", label: "Cédula de Ciudadanía" },
  { value: "CE", label: "Cedula de Extranjería" },
  { value: "PAS", label: "Pasaporte" },
  { value: "TI", label: "Tarjeta de Identidad" },
  { value: "PEP", label: "Permiso Especial de Permanencia" },
];

export const MONTHLY_INTENSITY = [
  { value: "12", label: "12" },
  { value: "18", label: "18" },
  { value: "24", label: "24" },
  { value: "30", label: "30" },
  { value: "36", label: "36" },
  { value: "42", label: "42" },
  { value: "48", label: "48" },
];

export const LANGUAGES = [
  { value: "EN", label: "Inglés" },
  { value: "FR", label: "Frances" },
];

export const ROL_OPTIONS = [
  { value: "ROLE_ADMIN", label: "Administrador" },
  { value: "ROLE_TEACHER", label: "Profesor" },
  { value: "ROLE_STUDENT", label: "Estudiante" },
];

export const PROGRAMS = [
  { value: "Master Live 50", label: "Master Live 50" },
  { value: "Master Live 70", label: "Master Live 70" },
  { value: "Master Live 100", label: "Master Live 100" },
  { value: "Master Presencial", label: "Master Presencial" },
  { value: "Master Live Fr", label: "Master Live Fr" },
  { value: "Master Live 50 Fr", label: "Master Live 50 Fr" },
  { value: "Master Live 70 Fr", label: "Master Live 70 Fr" },
  { value: "Master Live 100 Fr", label: "Master Live 100 Fr" },
  { value: "Master Presencial Fr", label: "Master Presencial Fr" },
  { value: "Master Presencial Ody", label: "Master Presencial Ody" },
  { value: "Master Presencial Cosmo", label: "Master Presencial Cosmo" },
];

export const LEVELS = [
  { value: "A1", label: "A1" },
  { value: "A1-1", label: "A1-1" },
  { value: "A2", label: "A2" },
  { value: "A2-1", label: "A2-1" },
  { value: "A3", label: "A3" },
  { value: "B1", label: "B1" },
  { value: "B2", label: "B2" },
  { value: "C1", label: "C1" },
  { value: "C1-E", label: "C1-E" },
  { value: "C1-O", label: "C1-O" },
];

export const CLASS_TYPES = [
  { value: "REGULAR", label: "Sesion Regular" },
  { value: "WORKSHOP", label: "Taller" },
  { value: "EXAM", label: "Examen" },
];

// ...existing code...
export const SUB_CLASS_TYPES = [
  { value: "FR-Club de conversación", label: "FR-Club de conversación" },
  { value: "FR-Gramática", label: "FR-Gramática" },
  { value: "FR-Escritura", label: "FR-Escritura" },
  { value: "FR-Pronunciación y escucha", label: "FR-Pronunciación y escucha" },
  { value: "FR-Interculturalidad", label: "FR-Interculturalidad" },
  { value: "FR-Específico", label: "FR-Específico" },
  { value: "FR-DELF/DALF", label: "FR-DELF/DALF" },
  { value: "FR-Le français professionnel", label: "FR-Le français professionnel" },
  { value: "IN-Club de conversación", label: "IN-Club de conversación" },
  { value: "IN-Gramática", label: "IN-Gramática" },
  { value: "IN-Escritura", label: "IN-Escritura" },
  { value: "IN-Pronunciación y escucha", label: "IN-Pronunciación y escucha" },
  { value: "IN-Interculturalidad", label: "IN-Interculturalidad" },
  { value: "IN-Específico", label: "IN-Específico" },
  {value: "IN-Exámenes internacionales", label: "IN-Exámenes internacionales"},
  {value: "IN-English At Workplace", label: "IN-English At Workplace"},
];

export const CAPACITYS = [
  { value: "0", label: "0" },
  { value: "3", label: "3" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "12", label: "12" },
];
